import React, { useContext } from 'react';

import { PhoneNumberInput as PhoneNumberInputComponent } from '../../../components/ui/Inputs/PhoneNumberInput';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

import StyledContent from './StyledContent';

export function PhoneNumberInput() {
  const { bindPhoneNumber, isLoading, invalidFields } = useContext(SignUpFormContext);
  useFieldErrorAnalytics({ field: 'phoneNumber', invalidFields });

  return (
    <StyledContent>
      <PhoneNumberInputComponent
        className='identity__field identity__field-phoneInput'
        name='phoneNumber'
        invalidFields={invalidFields}
        disabled={isLoading}
        {...bindPhoneNumber}
      />
    </StyledContent>
  );
}
